
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

import { getNavigations, getCurrentNavigation, getPreviousNavigation, removeFromHistory } from "../../slices/navigationSlice";
import { getLabel } from "../../tools/Dictionary";

import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import "./BackButton.css";

const BackButton = (props) => {

  
  //Props
  const Hide = props.Hide;
  const StyleContainer = props.StyleContainer || {};
  const StyleButton = props.StyleButton || {};

  //Redux
  const Dispatch = useDispatch();
  const CurrentNavigation = useSelector(getCurrentNavigation);
  const PreviousNavigation = useSelector(getPreviousNavigation);

  //Navigation
  const Navigate = useNavigate();



  const handleBack = () =>
  {

  
    if (PreviousNavigation){


      Navigate(PreviousNavigation.url + (PreviousNavigation.urlParamsText || ""));
      Dispatch(removeFromHistory(CurrentNavigation));


    }



  };

  if (Hide) return null;

  return (
    <div className="troubleshoot_return_cont" style={StyleContainer}>
      <div
        type="text"
        className="page_button_return"
        onClick={handleBack}
        style={StyleButton}
      >
        <div>
          <MdOutlineKeyboardArrowLeft />
        </div>
        <div>
          {getLabel("App", "Back")}
        </div>
      </div>
    </div>
  );

}

export default BackButton;
